import { useState, useEffect } from 'react';

export interface ScriptProps {
  src: string | null;
  checkForExisting?: boolean;
}

const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

export default function useScript({
  src,
  checkForExisting = false,
}: ScriptProps): [boolean, ErrorEvent | null] {
  const [loading, setLoading] = useState(Boolean(src));
  const [error, setError] = useState<ErrorEvent | null>(null);

  useEffect(() => {
    if (!isBrowser || !src) return;

    if (checkForExisting) {
      const existing = document.querySelectorAll(`script[src="${src}"]`);
      if (existing.length > 0) {
        setLoading(false);
        return;
      }
    }

    const scriptEl = document.createElement('script');
    scriptEl.setAttribute('src', src);

    const handleLoad = () => {
      setLoading(false);
    };
    const handleError = (error: ErrorEvent) => {
      setError(error);
      setLoading(false);
    };

    scriptEl.addEventListener('load', handleLoad);
    scriptEl.addEventListener('error', handleError);

    document.body.appendChild(scriptEl);

    return () => {
      scriptEl.removeEventListener('load', handleLoad);
      scriptEl.removeEventListener('error', handleError);
    };
  }, [src, checkForExisting]);

  return [loading, error];
}
